import React from "react";

const TailDragHandle = ({ x, y, onPointerDown }) => {
  return (
    <div
      data-testid="tail-drag-handle"
      onPointerDown={onPointerDown}
      style={{
        position: "absolute",
        left: x - 6,
        top: y - 6,
        width: 12,
        height: 12,
        boxSizing: "border-box",
        background: "#00a4e4",
        border: "2px solid #1a1a1a",
        boxShadow: "2px 2px 0 rgba(0,0,0,0.25)",
        cursor: "grab",
        zIndex: 16,
        pointerEvents: "auto",
        touchAction: "none",
      }}
    />
  );
};

export default TailDragHandle;
